import { Dispatch } from 'redux';
import { LanguageCode } from '../core/types/ILanguage';
import changeLanguage from './changeLanguage';

export default (language: LanguageCode) => (dispatch: Dispatch<any>) => {
    dispatch(changeLanguage(language));
}